import React,{ createContext, useReducer } from "react";
import Reducer from "../reducers/Reducer";

const Context = createContext();

export const Provider = ({ children }) => {
  const initialState = {
    home: {
      isValid:false,
      notes:"",
      documents:[],
      totalNeededFiles:0,
      totalUploadedFiles:0,
    },
   
    pages : {
      isPageActive:"home",
      previousPage:"",
    },
    // isPageActive:"home",
    // nextPage:"",
    // previousPage:"",
    tabStage: 1,
    loading: true,
    tracker:1,
    startTime:"",
  };

  const [state, dispatch] = useReducer(Reducer, initialState);

  return (
    <Context.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Context;
